package com.swetdot.swetgram.data.media

import kotlin.js.Promise
import kotlinx.coroutines.await

actual class ImagePicker : ImageSource {
    actual override suspend fun pick(purpose: UploadPurpose): PickedImage? {
        val bridge: dynamic = js("window.SwetgramBrowser")
        val image = (bridge.pickImage(purpose.maxEdgePx, ImageEncoding.JPEG_QUALITY / 100.0) as Promise<dynamic>).await()
            ?: return null
        val data = image.bytes
        return PickedImage(
            bytes = ByteArray(data.length as Int) { (data[it] as Int).toByte() },
            mimeType = ImageEncoding.OUTPUT_MIME_TYPE,
            width = image.width as Int,
            height = image.height as Int,
        )
    }
}
